// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_1Xwuog aLs3Nr","imageWrapper":"n4Ibey"};